import { render } from "./tagClassify.vue?vue&type=template&id=3ecbb062"
import script from "./tagClassify.vue?vue&type=script&lang=js"
export * from "./tagClassify.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/active/tagClassify.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ecbb062"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ecbb062', __exports__)) {
    console.log('reload')
    api.reload('3ecbb062', __exports__)
  }
  
  module.hot.accept("./tagClassify.vue?vue&type=template&id=3ecbb062", () => {
    console.log('re-render')
    api.rerender('3ecbb062', render)
  })

}


export default __exports__